import React, { useEffect, useState } from "react";
import MedicalCenterCard from "../../medical-center-list/medicalCenterCard";
import clinic1 from "../../../assets/images/clinic/clinic1.jpg";
import profile from "../../../assets/images/clinic/profile.png";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";
import { getCenters } from "../../../services/centerService";
import { Link } from "react-router-dom";


const ArrowIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={2.2}
    stroke="currentColor"
    className="w-3.5 h-3.5"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M10.5 4.5 3 12m0 0 7.5 7.5M3 12h18"
    />
  </svg>
);



export default function MedicalCarousel() {
  const [centers, setCenters] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchCenters = async () => {
      try {
        setLoading(true);

        const response = await getCenters({});

        if (response?.response_status === "success") {
          setCenters(response.data || []);
        } else {
          setError("خطا در دریافت اطلاعات از سرور");
        }
      } catch (err) {
        console.error(err);
        setError("برقراری ارتباط با سرور برقرار نشد.");
      } finally {
        setLoading(false);
      }
    };

    fetchCenters();
  }, []);

  const formattedCenters = React.useMemo(
    () =>
      centers.map((item) => ({
        id: item.uuid,
        title: item.title,
        city: item.city_title,
        address: item.address,
        category: item.category_title,
        treatmentGroup: item.group_title,
        ownership: item.type,
        status: "فعال",
        isOpen: item.is_open,
        img: item.cover_photo
          ? `https://bit.medizen.ir/i/${item.cover_photo}`
          : clinic1,
        profile: item.thumbnail
          ? `https://bit.medizen.ir/i/${item.thumbnail}`
          : profile,
      })),
    [centers],
  );

  // نمایش حالت لودینگ
  if (loading) {
    return (
      <div className="flex justify-center items-center h-40">
        <p className="text-gray-500 font-medium animate-pulse">
          در حال بارگذاری مراکز درمانی...
        </p>
      </div>
    );
  }

  // نمایش خطا در صورت بروز مشکل
  if (error) {
    return (
      <div className="flex justify-center items-center h-40">
        <p className="text-red-500 font-medium">{error}</p>
      </div>
    );
  }

  // اگر لیستی یافت نشد
  if (centers.length === 0) {
    return (
      <div className="flex justify-center items-center h-40">
        <p className="text-gray-500 font-medium">هیچ مرکز درمانی یافت نشد.</p>
      </div>
    );
  }

  return (
    <div className="">
      <div className="flex justify-center items-center mb-3 lg:mb-4 sm:px-2 ">
        <h3 className="flex items-center gap-4 w-full font-semibold text-[#383838]">
          <span className="flex-1 h-[2px] rounded-full bg-gradient-to-r from-purple/10 to-transparent"></span>
          <span className="flex items-center whitespace-nowrap px-2 text-[18px] md:text-[23px]">
            <span className="text-[#383838]">برترین</span>
            <span className="text-[#383838] mx-1.5">مراکز درمانی</span>
          </span>
          <span className="flex-1 h-[2px] rounded-full bg-gradient-to-l from-purple/10 to-transparent"></span>
        </h3>
      </div>

      <div className="w-full">
        <Swiper
          modules={[Autoplay]}
          spaceBetween={16}
          autoplay={{ delay: 3000, disableOnInteraction: false }}
          dir="rtl"
          slidesPerView={1}
          breakpoints={{
            768: {
              slidesPerView: 2,
            },
            1300: {
              slidesPerView: 3,
            },
          }}
        >
          {formattedCenters.map((center) => (
            <SwiperSlide key={center.id}>
              <MedicalCenterCard center={center} />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
      <div className="text-center items-center justify-center flex duration-300 mt-4 lg:mt-6">
        <Link
          to="/centers"
          className="
                  flex
                  items-center
                  gap-1.5
                  text-purple
                  text-[12px]
                  font-medium
                  hover:gap-3
                  transition-all
                  "
        >
          مشاهده همه
          <ArrowIcon />
        </Link>
      </div>
    </div>
  );
}
